import { render, staticRenderFns } from "./r-checkbox.vue?vue&type=template&id=036b31bf&"
import script from "./r-checkbox.vue?vue&type=script&lang=js&"
export * from "./r-checkbox.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./r-checkbox.vue?vue&type=style&index=0&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports